import React from "react"
import Swal from "sweetalert2"

export default function ProductCard({
  p,
  onAddToCart,
  onContactSeller,
  onDirections,
}) {
  return (
    <div className="border border-gray-200 rounded-xl overflow-hidden bg-white shadow-sm flex flex-col">
      {/* Imagen del producto */}
      <div className="aspect-video bg-gray-100 overflow-hidden">
        {p.image_url ? (
          <img
            src={p.image_url}
            alt={p.name}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full grid place-items-center text-gray-400">
            Sin imagen
          </div>
        )}
      </div>

      {/* Contenido */}
      <div className="p-5 flex-1 flex flex-col gap-3">
        <h3 className="text-xl font-semibold text-gray-900">{p.name}</h3>
        <p className="text-sm text-gray-700">{p.description}</p>

        {/* Precio + teléfono + distancia */}
        <div className="mt-1 flex flex-col gap-2">
          <span className="text-2xl font-bold text-gray-900">
            ${p.price?.toFixed?.(2) ?? p.price}
          </span>

          {p.phone && (
            <a
              href={`tel:${p.phone}`}
              className="inline-flex items-center gap-2 text-sm text-gray-700"
            >
              <span>📞</span>
              <span>{p.phone}</span>
            </a>
          )}

          {/* Distancia: usa __distanceKm calculado en PublicProductList */}
          <span className="text-sm text-gray-600">
            Distancia:{" "}
            {typeof p.__distanceKm === "number" &&
            Number.isFinite(p.__distanceKm)
              ? `${p.__distanceKm.toFixed(2)} km`
              : "No disponible"}
          </span>
        </div>

        {/* Botones */}
        <div className="pt-2 flex gap-2 flex-wrap">
          <button
            type="button"
            onClick={() => onAddToCart?.(p)}
            className="px-4 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white text-sm"
            title="Agregar al comparador"
          >
            Agregar al Comparador
          </button>

          <button
            type="button"
            onClick={() => {
              // Intentar abrir WhatsApp con el número del producto
              const raw = p?.contacto || ""
              const digits = String(raw).replace(/\D/g, "")
              const message = `Hola, estoy interesado en el producto: ${
                p?.name || ""
              } "que tienes publicado en Quipusmania.com"`
              const encoded = encodeURIComponent(message)

              if (digits && digits.length >= 6) {
                const url = `https://wa.me/${digits}?text=${encoded}`
                // Intentar abrir en nueva pestaña; si falla, navegar en la misma
                try {
                  window.open(url, "_blank")
                } catch (e) {
                  window.location.href = url
                }
                return
              }

              // Si no hay suficientes dígitos para WhatsApp pero hay número, intentar llamada telefónica
              if (digits && digits.length > 0) {
                const tel = `tel:${digits}`
                try {
                  window.open(tel, "_self")
                } catch (e) {
                  window.location.href = tel
                }
                return
              }

              // Fallback al handler si no hay número válido
              if (typeof onContactSeller === "function") {
                onContactSeller(p)
                return
              }

              // Último recurso: avisar al usuario mediante SweetAlert2
              Swal.fire({
                icon: "info",
                title: "Sin contacto",
                text: "No hay número de contacto disponible para este producto.",
              })
            }}
            className="px-4 py-2 rounded-md border border-gray-300 bg-white hover:bg-gray-50 text-sm text-gray-900"
            title="Contactar vendedor por WhatsApp"
          >
            Contactar vendedor
          </button>
          {/* 
          {p.geo_lat && p.geo_lng && onDirections && (
            <button
              type="button"
              onClick={() => onDirections(p)}
              className="px-4 py-2 rounded-md border border-gray-300 bg-white hover:bg-gray-50 text-sm text-gray-900"
              title="Ver en el mapa"
            >
              Ver en el mapa
            </button>
          )} */}
        </div>
      </div>
    </div>
  )
}
